import { t } from '../../i18n.es.js';
import React from 'react';
import { styled, Currency } from '@teko/ds-desktop';
import { DiscountFilled, VoucherColored } from '@teko/ds-icon';
import { DetailGifts, Quantity } from '../DetailGifts/DetailGifts.es.js';

const DefaultPromotions = ({
  gifts,
  discount,
  vouchers = []
}) => {
  return /* @__PURE__ */ React.createElement(React.Fragment, null, discount > 0 && /* @__PURE__ */ React.createElement(Wrapper, null, /* @__PURE__ */ React.createElement("div", {
    style: { width: "8%" }
  }, /* @__PURE__ */ React.createElement(DiscountFilled, {
    size: 20,
    color: "primary500",
    style: { marginLeft: "5px" }
  })), /* @__PURE__ */ React.createElement("div", {
    style: { width: "92%" }
  }, t("Gi\u1EA3m tr\u1EF1c ti\u1EBFp"), " ", /* @__PURE__ */ React.createElement(StyledCurrency, {
    value: discount
  }))), !!gifts.length && /* @__PURE__ */ React.createElement(DetailGifts, {
    gifts
  }), vouchers.map((voucher, index) => /* @__PURE__ */ React.createElement(Wrapper, {
    key: index
  }, /* @__PURE__ */ React.createElement("div", {
    style: { width: "8%" }
  }, /* @__PURE__ */ React.createElement(VoucherColored, {
    size: 20,
    color: "primary500",
    style: { marginLeft: "5px" }
  })), /* @__PURE__ */ React.createElement("div", {
    style: { width: "92%" }
  }, t("T\u1EB7ng"), " ", /* @__PURE__ */ React.createElement(Quantity, null, "x", voucher.quantity), " ", /* @__PURE__ */ React.createElement(StyledVoucherName, null, voucher.name)))));
};
const Wrapper = styled.div`
  margin-top: 2px;
  display: flex;
`;
const StyledCurrency = styled(Currency)`
  margin: 0 4px;
  color: #ed2101;
  font-weight: 500;
`;
const StyledVoucherName = styled.span`
  color: #ed2101;
  font-weight: 500;
`;

export { DefaultPromotions };
